var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 11.3168V39.0601C51.3333 41.3234 49.49 43.4001 47.2267 43.6801L46.5033 43.7734C42.6767 44.2867 37.2867 45.8734 32.9467 47.6934C31.43 48.3234 29.75 47.1801 29.75 45.5234V13.0668C29.75 12.2034 30.24 11.4101 31.01 10.9901C35.28 8.68008 41.7433 6.62675 46.13 6.25342H46.27C49.07 6.25342 51.3333 8.51675 51.3333 11.3168Z",
    fill: "#D8DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9902 10.9901C20.7202 8.68008 14.2569 6.62675 9.87022 6.25342H9.70689C6.90689 6.25342 4.64355 8.51675 4.64355 11.3168V39.0601C4.64355 41.3234 6.48689 43.4001 8.75022 43.6801L9.47355 43.7734C13.3002 44.2867 18.6902 45.8734 23.0302 47.6934C24.5469 48.3234 26.2269 47.1801 26.2269 45.5234V13.0668C26.2269 12.1801 25.7602 11.4101 24.9902 10.9901ZM11.6669 18.0601H16.9169C17.8736 18.0601 18.6669 18.8534 18.6669 19.8101C18.6669 20.7901 17.8736 21.5601 16.9169 21.5601H11.6669C10.7102 21.5601 9.91689 20.7901 9.91689 19.8101C9.91689 18.8534 10.7102 18.0601 11.6669 18.0601ZM18.6669 28.5601H11.6669C10.7102 28.5601 9.91689 27.7901 9.91689 26.8101C9.91689 25.8534 10.7102 25.0601 11.6669 25.0601H18.6669C19.6236 25.0601 20.4169 25.8534 20.4169 26.8101C20.4169 27.7901 19.6236 28.5601 18.6669 28.5601Z",
    fill: "#D8DEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.8f0d306e328af5d403a6451b34bf0629.svg";
export { ForwardRef as ReactComponent };